export default __webpack_public_path__ + "static/media/Other.0eb945b9.svg";